import _Object$values from 'babel-runtime/core-js/object/values';
import get from 'lodash/get';
import { capitalize } from './string';
import { getObjectIndexInArrayMatchingAtLeastOneField } from './array';

export var getDisplayName = function getDisplayName(user) {
  var displayName = 'Unknown';
  if (user.displayName) {
    displayName = user.displayName.substr(0, user.displayName.indexOf(' '));
  } else if (user.email) {
    displayName = user.email.substr(0, user.email.indexOf('@'));
  }
  return capitalize(displayName);
};

export var getDisplayNames = function getDisplayNames(users) {
  var displayNames = '';
  for (var i in users) {
    if (i > 0) {
      displayNames += ', ';
    }
    displayNames += getDisplayName(users[i]);
  }
  return displayNames;
};

export var getDisplayNamesFromObject = function getDisplayNamesFromObject(dict) {
  var values = _Object$values(dict);
  var displayNames = '';
  for (var i in values) {
    if (i > 0) {
      displayNames += ', ';
    }
    displayNames += values[i];
  }
  return displayNames;
};

export var getKey = function getKey(user) {
  return get(user, 'userId') || get(user, 'email');
};

export var areSameUser = function areSameUser(user1, user2) {
  return getKey(user1) == getKey(user2);
};

export var toUser = function toUser(obj) {
  if (!obj) {
    return undefined;
  }
  var user = {};
  user.userId = obj.userId;
  user.email = obj.email;
  user.displayName = obj.displayName;
  user.picture = obj.picture;
  return user;
};

export var getUserIndexInList = function getUserIndexInList(array, user) {
  return getObjectIndexInArrayMatchingAtLeastOneField(array, user, ['userId', 'email']);
};

export var computeUserFromSessionUser = function computeUserFromSessionUser(obj) {
  if (!obj) {
    return undefined;
  }
  var user = {};
  user.userId = obj.id;
  user.displayName = obj.displayName;
  user.picture = obj.picture;
  return user;
};

export var cleanWatchers = function cleanWatchers(watchers) {
  return watchers.map(function (watcher) {
    return watcher.userId ? { userId: watcher.userId, isReviewer: !!watcher.isReviewer } : { email: watcher.email, isReviewer: !!watcher.isReviewer };
  });
};
//# sourceMappingURL=user.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/user.js
// module id = 398
// module chunks = 0